import request from '@/utils/request';
import type {
  IIrPostCreateRequest,
  IIrPostApproveRequest,
  IIrPostRejectRequest,
  IIrPostCancelRequest,
  IIrPostCommentCreateRequest,
  IIrPostListParams,
  IIrPostSummary, // IIrPostSummary 타입 임포트 추가
} from '@/types/irPost';

// ================== API Functions ==================

const PATH = '/irPost';

/**
 * IR 게시글 생성
 */
export const createPost = (data: IIrPostCreateRequest) => request({
  url: PATH,
  method: 'post',
  data,
});

/**
 * IR 게시글 목록 조회 (fromUserUid 기준, 페이징)
 * @param params { fromUserUid: string, page?: number, size?: number, sort?: string }
 * @returns { Promise<AxiosResponse<Page<IIrPostSummary>>> } 페이징된 게시글 목록 응답
 */
export const getPosts = (params: IIrPostListParams) => request({
  url: `${PATH}`,
  method: 'get',
  params,
});

/**
 * IR 게시글 상세 조회
 * @param postId 게시글 ID
 */
export const getPost = (postId: string) => request({
  url: `${PATH}/${postId}`,
  method: 'get',
});

/**
 * IR 게시글 승인 (관리자용)
 * @param postId 게시글 ID
 * @param data { approverUid: string }
 */
export const approvePost = (postId: string, data: IIrPostApproveRequest) => request({
  url: `${PATH}/${postId}/approve`,
  method: 'put',
  data,
});

/**
 * IR 게시글 반려 (관리자용)
 * @param postId 게시글 ID
 * @param data { approverUid: string, cancelReason: string }
 */
export const rejectPost = (postId: string, data: IIrPostRejectRequest) => request({
  url: `${PATH}/${postId}/reject`,
  method: 'put',
  data,
});

/**
 * IR 게시글 취소
 * @param postId 게시글 ID
 * @param data { cancelReason: string }
 */
export const cancelPost = (postId: string, data: IIrPostCancelRequest) => request({
  url: `${PATH}/${postId}/cancel`,
  method: 'put',
  data,
});

/**
 * 댓글 생성
 * @param data { postId: number, content: string }
 */
export const addComment = (data: IIrPostCommentCreateRequest) => request({
  url: `${PATH}/comments`,
  method: 'post',
  data,
});

/**
 * 관리자 연락처 조회
 */
export const getAdminPhone = () => request({
  url: `${PATH}/admin/phone`,
  method: 'get',
});
